import React from 'react';
import { Summary } from '../../containers/orders-drawer/sections/summary';
import { Tags } from '../../containers/orders-drawer/sections/tags';
import { Customer } from '../../containers/orders-drawer/sections/customer';
import { Notes } from '../../containers/orders-drawer/sections/notes';
import { OrderedItems } from '../../containers/orders-drawer/sections/ordered-items';
import { SingleOrderCsw } from '../../containers/orders-drawer/sections/single-order-csw';
import { Customs } from '../../containers/orders-drawer/sections/customs';
import { OtherShippingOptions } from '../../containers/orders-drawer/sections/other-shipping-options';
import { PickupInformation } from '../../components/orders-drawer/sections/pickup-information';

import { PICKUP_INFORMATION } from '../../constants/csw-ids';

//  this is what the collection saved in the user setting looks like for v2
//  ['Shipping', 'Recipient', 'Items', 'Summary', 'Notes', 'Tags', 'Customs']

export const singleSelectionComponentMap = [
  {
    name: 'SingleOrderCSW',
    render: () => <SingleOrderCsw />,
    v2Name: 'Shipping',
  },
  {
    name: 'OrderedItems',
    render: () => <OrderedItems />,
    v2Name: 'Items',
  },
  {
    name: 'Customer',
    render: () => <Customer />,
    v2Name: 'Recipient',
  },
  {
    name: 'Notes',
    render: () => <Notes />,
    v2Name: 'Notes',
  },
  {
    name: 'Summary',
    render: () => <Summary />,
    v2Name: 'Shipping',
  },
  {
    name: 'Tags',
    render: () => <Tags />,
    v2Name: 'Tags',
  },
  {
    name: 'Customs',
    render: () => <Customs />,
    v2Name: 'Customs',
  },
  {
    name: 'OtherShippingOptions',
    render: () => <OtherShippingOptions />,
    v2Name: 'Shipping',
  },
  {
    name: PICKUP_INFORMATION,
    render: () => <PickupInformation />,
    v2Name: 'Shipping',
  },
];
